import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";
import { ShowTaxiBooking } from "../../API/Concierge";
import axios from "../../axios";
import { Button, Form, Toast } from "react-bootstrap";
import BannerServices from "../../new-components/banner-home/BannerServices";
import HeaderInner from "../../Components/HeaderInner";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import { trackTaxiOrderTrackingOpened } from "../../utils/mixpanel";
// removed phone input component for TaxiBooking

export const TaxiBooking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const [name, setName] = useState("");
  const [timeInput, setTimeInput] = useState();
  const [dateInput, setDateInput] = useState();
  const [peopleCount, setPeopleCount] = useState(1);
  const [luggageCount, setLuggageCount] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const { t } = useTranslation();
  const toast = useRef(null);
  const lang = sessionStorage.getItem("lang");
  const { theme } = useContext(ThemeContext);

  const { data: TaxiBookingData, isLoading } = ShowTaxiBooking(room_uuid, lang);

  useEffect(() => {
    const currentTime = new Date();

    // Format the time as HH:mm (hours and minutes)
    const hours = new Date(Date.now()).getHours().toString().padStart(2, "0");
    const minutes = currentTime.getMinutes().toString().padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`;

    const currentDate = new Date();

    // Format the date as YYYY-MM-DD (required by input type="date")

    const formattedDate = currentDate.toISOString().slice(0, 10);

    setDateInput(formattedDate);
    setTimeInput(formattedTime);
  }, []);
  const currentTimem = new Date(`${dateInput}T${timeInput}`);
  const dubaiTime = currentTimem.toLocaleString("en-US", {
    timeZone: "Asia/Dubai",
  });

  const dateObj = new Date(dubaiTime);
  const hoursD = dateObj.getHours().toString().padStart(2, "0");
  const minutesD = (dateObj.getMinutes() + 1).toString().padStart(2, "0");
  const time = `${hoursD}:${minutesD}`;

  const handleTime = (e) => {
    setTimeInput(e.target.value);
  };
  const handleDate = (e) => {
    setDateInput(e.target.value);
  };

  const sendData = {
    type_id: "taxi-booking",
    name,
    people_no: peopleCount,
    luggage_count: luggageCount,
    time: time,
    date: dateInput,
  };
  const handelBook = () => {
    setIsDisabled(true);

    axios
      .post(`/${room_uuid}/concierge/book-service`, sendData, {
        headers: {
          lang: lang,
        },
      })
      .then((res) => {
        if (res.data.status == false) {
          toast.current.show({
            severity: "error",
            summary: t("Error"),
            detail: t(`${res.data.message}`),
            life: 4000,
          });
        }
        // console.log("res", res);
        if (res.data.status) {
          // Track taxi order tracking opened
          // trackTaxiOrderTrackingOpened({
          //   order_number: res.data.data?.order_number || res.data.data?.orderNumber || "",
          // });

          navigate(`/${room_uuid}/HKOrderPlaced`, {
            state: {
              metadata: {
                res: res.data.data,
              },
            },
          });
        }

        setIsDisabled(false);
      })
      .catch((err) => {
        setIsDisabled(false);
        console.log(err);
      });
  };
  return (
    <div className={theme ? "food" : ""}>
      {theme ? (
        <Title title={TaxiBookingData?.center_header} />
      ) : (
        <HeaderInner headerName={TaxiBookingData?.center_header} />
      )}
      <main className="home-main bg-white back-white book-table pad-top-0">
        <Toast ref={toast} position="bottom-center" />

        {isLoading ? (
          <SpaLoader />
        ) : (
          <>
            {theme ? (
              <BannerServices headerImages={[TaxiBookingData?.image]} />
            ) : (
              <div className="con-order-img">
                <img src={TaxiBookingData?.image} alt="" />
              </div>
            )}

            <p className="bk-title mt-3">
              {t(`${TaxiBookingData?.center_header}`)}
            </p>
            <div className="px-5">
              <div className="con-email">
                <Form.Group
                  className="mb-3  align-items-center dark-placeholder justify-content-start "
                  controlId="formBasicname"
                >
                  <Form.Control
                    type="email"
                    placeholder={t("Your Name (Optional)")}
                    className="w-100 py-3"
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>
              </div>
              <div className="bk-people">
                <Form.Group
                  className="mb-3 row align-items-center justify-content-start"
                  controlId="peopleCount"
                >
                  <p className="col-6 m-0 pl-4"> {t("Number of people")} </p>
                  <Form.Control
                    type="number"
                    min={1}
                    value={peopleCount}
                    onChange={(e) =>
                      setPeopleCount(Number(e.target.value) || 1)
                    }
                    className="col-5 ml-2"
                  />
                </Form.Group>
              </div>

              <div className="bk-luggage">
                <Form.Group
                  className="mb-3 row align-items-center justify-content-start"
                  controlId="luggageCount"
                >
                  <p className="col-6 m-0 pl-4"> {t("Luggage Count")} </p>
                  <Form.Control
                    type="number"
                    min={0}
                    value={luggageCount}
                    onChange={(e) =>
                      setLuggageCount(Number(e.target.value) || 0)
                    }
                    className="col-5 ml-2"
                  />
                </Form.Group>
              </div>

              <div className="bk-date">
                <Form.Group
                  className="mb-3 row align-items-center justify-content-start"
                  controlId="formBasicname"
                >
                  <p className="col-3 m-0 pl-4"> {t("Date")} </p>
                  <Form.Control
                    type="date"
                    value={dateInput}
                    onChange={handleDate}
                    className="col-8 ml-2 date-input dt-input"
                  />
                </Form.Group>
              </div>
              <div className="bk-time mb-4">
                <Form.Group
                  className="mb-3 row align-items-center justify-content-start "
                  controlId="formBasicname"
                >
                  <p className="col-3 m-0 pl-4 no-break"> {t("Time")} </p>
                  <Form.Control
                    type="time"
                    value={timeInput}
                    onChange={handleTime}
                    className="col-8 ml-2 time-input dt-input"
                  />
                </Form.Group>
              </div>
            </div>
            <div className="padd-div text-center mt-5">
              <Button
                className="reg-btn book lg"
                disabled={isDisabled}
                onClick={handelBook}
                // to={`/${room_uuid}/HKOrderPlaced`}
              >
                {t("Send")}
              </Button>
            </div>
            <div className="padd-div text-center">
              {/* <h3 className="text-center">
                <TaxInclusive />
              </h3>{" "} */}
            </div>
            <div className="spacer-40 my-5"></div>
          </>
        )}
      </main>
      {theme && <NewFooter />}
    </div>
  );
};
